import { useEffect, useState } from "react";
import { Users } from "lucide-react";
import { api, fmtDate, fmtTime, EVENT_LABEL } from "../../lib/api";
import { PageHeader, StatusPill, Empty } from "../../components/common";
import { PhotoLog } from "../staff/Attendance";

export default function Team() {
  const [team, setTeam] = useState([]);
  const [sel, setSel] = useState("");
  const [records, setRecords] = useState([]);

  useEffect(() => { api.get("/employer/team").then((r) => setTeam(r.data)); }, []);
  useEffect(() => { api.get("/attendance/records", { params: { days: 7, staff_id: sel || undefined } }).then((r) => setRecords(r.data)); }, [sel]);

  return (
    <div>
      <PageHeader eyebrow="Workforce" title="My team" subtitle="Staff you hired through Dexterity. Check photo evidence for every clock in, break and clock out." />
      {team.length === 0 ? <Empty icon={Users} title="No staff on your team yet" text="Move a candidate to 'hired' in a job pipeline to add them here." testid="team-empty" /> : (
        <>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
            {team.map((t) => (
              <button key={t.staff_id} onClick={() => setSel(sel === t.staff_id ? "" : t.staff_id)} data-testid={`team-member-${t.staff_id}`}
                className={`text-left dx-card p-5 transition-colors ${sel === t.staff_id ? "ring-2 ring-[#D4AF37]" : ""}`}>
                <div className="flex justify-between gap-2"><span className="font-display font-semibold">{t.staff_name}</span><StatusPill status={t.attendance_state} /></div>
                <div className="text-sm text-[#6b5a73]">{t.job_title} · since {fmtDate(t.started_at)}</div>
                {t.last_event && <div className="text-xs text-[#8a7a92] mt-2">Last: {EVENT_LABEL[t.last_event.type]} at {fmtTime(t.last_event.timestamp)}</div>}
              </button>
            ))}
          </div>
          <h3 className="font-display font-semibold text-lg mb-4">Photo evidence - last 7 days {sel && "· filtered"}</h3>
          {records.length ? <PhotoLog records={records} showName /> : <p className="text-sm text-[#6b5a73]">No attendance records yet.</p>}
        </>
      )}
    </div>
  );
}
